import dayjs from '@/js/libs/dayjs/index.ts';
export const getDateTime = (value, dateFormat, showLocal, startOfDay) => {
    if (!value) {
        return null;
    }
    if (showLocal) {
        return startOfDay ? dayjs(value, dateFormat).local().startOf('day').toDate() : dayjs(value, dateFormat).local().toDate();
    }
    return startOfDay ? dayjs(value, dateFormat).startOf('day').utc().toDate() : dayjs(value, dateFormat).endOf('day').utc().toDate();
};
// react-datepicker depends on date-dns, which fails to parse the 4-digit years with leading zero
// it's extremely unlikely we need such range to be selectable, so we only allow to set year >= 1000
export const isValid = (date) => date.isValid() && date.year() >= 1000;
export const isEqualDateRange = (a, b) => a ? a?.[0]?.toDateString() === b?.[0]?.toDateString() && a?.[1]?.toDateString() === b?.[1]?.toDateString() : false;
